import React, { useState } from 'react'
import { Button } from '../../common'
import { FiExternalLink, FiShare2 } from 'react-icons/fi'
import { Association, Team } from '../../types/generated.types'
import ShareWebshop from '../webshop/ShareWebshop'
import { useQuery } from '@apollo/client'
import { getVisibleAssociationsWithTeamsQuery } from '../../queries/association'
import SaEnkeltHomeIcon from '../../img/sa-enkelt-home.svg'

type Props = {
  children?: React.ReactNode
  association: Association
  shopShareDomain: string | undefined
  team?: Team
}

const Webbshop: React.FC<Props> = ({ association, team, shopShareDomain, children }) => {
  const [showShareModal, setShowShareModal] = useState(false);

  // Check if this association is the only one on the domain (no teams)
  const domain = shopShareDomain?.replace(/^https?:\/\//, '') || window.location.hostname;
  const { data: visibleAssociationsData, loading } = useQuery(getVisibleAssociationsWithTeamsQuery, {
    variables: { domain },
    skip: !association?.slug
  });

  const visibleAssociations = visibleAssociationsData?.visibleAssociationsWithTeams || [];
  // Only apply logic for association-level shops (when team is undefined)
  const isOnlyAssociation = !team && visibleAssociations.length === 1 &&
    visibleAssociations[0]?._id === association?._id &&
    visibleAssociations[0]?.teams?.length === 0;

  // Use short URL if association is alone, otherwise use full URL
  const shareDomain = isOnlyAssociation
    ? shopShareDomain?.replace(/^https?:\/\//, '')
    : team
      ? (`${shopShareDomain}/${association?.slug}/${team?.slug}`).replace(/^https?:\/\//, '')
      : (`${shopShareDomain}/${association?.slug}`).replace(/^https?:\/\//, '');

  const handleCloseShareModal = () => setShowShareModal(false);
  const handleOpenShareModal = () => setShowShareModal(true);

  const handleVisit = () => {
    const shopUrl = isOnlyAssociation
      ? shopShareDomain
      : team
        ? `${shopShareDomain}/${association?.slug}/${team?.slug}`
        : `${shopShareDomain}/${association?.slug}`;
    window.open(shopUrl, '_blank');
  };

  return (
    <>
      <div className="container flex justify-center mb">
        <div className="box md">
          <h3>Webbshop</h3>
          <div className="shop-domain flex justify-left items-center gap-1">
            <img src={SaEnkeltHomeIcon} alt="" />
            {association && !loading ? shareDomain : 'Laddar...'}
          </div>
          <div className="webshop-buttons">
            <Button className='primary md' onClick={handleOpenShareModal}>
              <span className='flex items-center justify-center gap-1'>
                Dela
                <FiShare2 />
              </span>
            </Button>
            <Button className='primary md' onClick={handleVisit}>
              <span className='flex items-center justify-center gap-1'>
                Besök
                <FiExternalLink />
              </span>
            </Button>
          </div>
          {children}
        </div>
      </div>

      {showShareModal &&
        <ShareWebshop
          isMyWebshop
          shopShareDomain={shopShareDomain || ''}
          associationSlug={association?.slug || ''}
          teamSlug={team?.slug || ''}
          closeModal={handleCloseShareModal}
        />
      }
    </>
  )
}

export default Webbshop
